'use strict';

angular.module('cgmemApp')
  .controller('AccountEditCtrl', function ($q, $rootScope, $scope, $state, $stateParams, $log, WorkingAccount, AppConfig, User) {
		$q.all([AppConfig.get(), WorkingAccount.get(), User.get()])
		.then(function(d) {
			$scope.account = d[1].account;
			$scope.accountTypes = d[0].accountTypes;
			$scope.isInGroup = User.isInGroup;
		});

		var errCB = function(err) {
			$rootScope.$emit('generalAlert','Error updating account: '+err.statusText);
		};
		
		$scope.ok = function () {
			$scope.account.$update(function() {}, errCB);
			$state.go("authenticated.profile");
		};

		$scope.cancel = function () {
			$state.go("authenticated.profile");
		};
		
  });
